import { useEffect, useState } from 'react'
import _ from 'lodash'
import {
  Link,
  Grid,
  Box,
  Typography,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Popover,
} from '@material-ui/core'
import history from '../../routes/history'
import Pagination from '@material-ui/lab/Pagination'
import TuneIcon from '@material-ui/icons/Tune'
import { ArrowUpward, ArrowDownward, InfoOutlined } from '@material-ui/icons'
import { SORTORDER } from '../../utils/constants'
import StatusButton from '../StatusButton'
import { useStyles } from './styles'

const getStatusColor = (status) => {
  switch (status) {
    case 'submitted':
      return '#CFC338'
    case 'approved':
      return '#35C37D'
    case 'rejected':
      return '#FF6565'
    case 'report_generated':
      return '#026AE3'
    case 'unenrolled':
      return '#CBCBCB'
    default:
      return '#FFF'
  }
}

const getStatusText = (status) => {
  switch (status) {
    case 'submitted':
      return 'Submitted for Enphase Review'
    case 'approved':
      return 'Approved by Enphase'
    case 'rejected':
      return 'Rejected by Enphase'
    case 'report_generated':
      return 'Evidence report mailed'
    case 'unenrolled':
      return 'Unenrolled'
    default:
      return 'Not Valid'
  }
}
export default function TableOutline(props) {
  const classes = useStyles()
  const { tableData, tableHeadings, page, rowsPerPage, totalElement } = props
  const [startIndex, setStartIndex] = useState(0)
  const [endIndex, setEndIndex] = useState(0)
  const [totalPageCount, setTotalPageCount] = useState(0)
  const [anchorEl, setAnchorEl] = useState(null)
  const [infoAnchorEl, setInfoAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleInfoClick = (event) => {
    setInfoAnchorEl(event.currentTarget)
  }

  const handleInfoClose = () => {
    setInfoAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'dropsown-popover' : undefined

  const openInfo = Boolean(infoAnchorEl)
  const infoId = openInfo ? 'dropsown-popover' : undefined

  const hasLink = (id) => {
    return tableHeadings.some((obj) => {
      return obj.id === id && obj.isLink
    })
  }

  const hasActive = (id) => {
    return tableHeadings.some((obj) => obj.id === id && obj.isActive === true)
  }

  useEffect(() => {
    const startPoint = (page - 1) * rowsPerPage + 1
    let endPoint = startPoint + rowsPerPage - 1
    endPoint = endPoint > totalElement ? totalElement : endPoint
    const pageCount = Math.ceil(totalElement / rowsPerPage)
    setStartIndex(totalElement === 0 ? 0 : startPoint)
    setEndIndex(endPoint)
    setTotalPageCount(pageCount)
  }, [rowsPerPage, totalElement, page])

  return (
    <Grid className={classes.spacing} container>
      <TableContainer className={classes.table} component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {tableHeadings.map((obj, index) => {
                return (
                  <TableCell
                    key={index}
                    className={`${classes.tableHeader} ${obj.className ? obj.className : ''
                      }`}
                  >
                    {obj.isDropdown ?
                      <>
                        <Button
                          className={`${classes.headerWrapper} ${classes.tableHeading}`}
                          aria-describedby={id}
                          variant="contained"
                          disableElevation
                          disableRipple
                          disableFocusRipple
                          style={{ backgroundColor: 'transparent' }}
                          onClick={handleClick}
                          endIcon={<TuneIcon />}
                        >
                          {obj.header}
                        </Button>
                        <Popover
                          id={id}
                          open={open}
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                          }}
                          PaperProps={{
                            className: classes.popoverPaper,
                          }}
                        >
                          {obj.dropDownValues.map((value, index) => (
                            <Box className={`${classes.dropDownValues} ${value === props.selectedStatus ? classes.active : ''}`} key={index} p={1.5} onClick={() => { props.handleDropdownChange(value); handleClose() }}>{value}</Box>
                          ))}
                        </Popover>
                      </> :
                      obj.isPopover ?
                        <>
                          <Button
                            className={`${classes.headerWrapper} ${classes.tableHeading}`}
                            aria-describedby={id}
                            variant="contained"
                            disableElevation
                            disableRipple
                            disableFocusRipple
                            style={{ backgroundColor: 'transparent', cursor: 'default' }}
                            endIcon={<InfoOutlined className={classes.infoIcon} onClick={handleInfoClick} />}
                          >
                            {obj.header}
                          </Button>
                          <Popover
                            id={infoId}
                            open={openInfo}
                            anchorEl={infoAnchorEl}
                            onClose={handleInfoClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left',
                            }}
                            PaperProps={{
                              className: classes.timePopoverPaper,
                            }}
                          >
                            <Box className={classes.timestampPopover} p={1.5}>
                              {obj.popoverContent}
                            </Box>
                          </Popover>
                        </> :
                        <IconButton
                          size="small"
                          edge="start"
                          classes={{ root: classes.iconbuttonroot }}
                          className={`${classes.headerWrapper} ${obj.isSortable ? '' : classes.noPointer
                            }`}
                          disableRipple={true}
                          onClick={() =>
                            obj.isSortable && props.handleSortData(obj)
                          }
                        >
                          {_.get(obj, 'header', '')}
                          {obj.isSortable &&
                            (obj.sortOrder === SORTORDER.ASC ? (
                              <ArrowUpward
                                fontSize="small"
                                className={classes.sortIcon}
                              />
                            ) : (
                              <ArrowDownward
                                fontSize="small"
                                className={classes.sortIcon}
                              />
                            ))}
                        </IconButton>}
                  </TableCell>
                )
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow key={index}>
                {row.map((obj, index) => {
                  return (
                    <TableCell key={index} className={obj.className}>
                      {hasLink(obj.id) ? (
                        <Link
                          component="button"
                          variant="body2"
                          onClick={() =>
                            history.push(
                              `/sitestatus/${_.get(row[0], 'value', '')}`,
                            )
                          }
                          style={{ color: '#3B86FF', paddingLeft: '0.4em' }}
                        >
                          {_.get(obj, 'value', '')}
                        </Link>
                      ) : hasActive(obj.id) ? (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'centre',
                          }}
                        >
                          <StatusButton
                            color={getStatusColor(_.get(row[4], 'value', ''))}
                            text={getStatusText(_.get(row[4], 'value', ''))}
                          ></StatusButton>
                        </div>
                      ) : (
                        <Typography style={{ color: '#4A4A4A' }}>
                          {_.get(obj, 'value', '')}
                        </Typography>
                      )}
                    </TableCell>
                  )
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box className={classes.paginationWrapper}>
        <Box className={classes.paginationSelectWrapper}>
          <Typography>Rows per page</Typography>
          <Select
            value={rowsPerPage}
            onChange={(event) =>
              props.handleChangeRowsPerPage(event.target.value)
            }
            classes={{ root: classes.selectRoot }}
            className={classes.selectWrapper}
          >
            {props.rowsPerPageOptions.map((value) => {
              return <MenuItem value={value}>{value}</MenuItem>
            })}
          </Select>
          <Typography>{`${startIndex}-${endIndex} of ${totalElement}`}</Typography>
        </Box>
        <Pagination
          page={page}
          count={totalPageCount}
          shape="rounded"
          onChange={(event, newPage) => {
            props.handleChangePage(newPage)
          }}
        />
      </Box>
    </Grid>
  )
}

TableOutline.defaultProps = {
  tableData: [],
  tableHeadings: [],
  pagination: false,
  rowsPerPage: 10,
  page: 1,
  totalElement: 0,
  rowsPerPageOptions: [10, 25, 50, 100],
  handleChangePage: () => { },
  handleChangeRowsPerPage: () => { },
  handleSortData: () => { },
}
